export default __webpack_public_path__ + "images/MH.e6df112.png";